export default (props, vars) => props?.['name'] === 'info';
